// extracted by mini-css-extract-plugin
export default {"PricingCardServices":"PricingCardServices_PricingCardServices__Nj5H0","listItem":"PricingCardServices_listItem__mdvkh"};